import React from 'react'
import MosaicInput from './MosaicInput'
import CheckBox from '../../../../../components/form/checkbox'
import PropTypes from 'prop-types'

function BasicInfo ({ state, onChange }) {
  return (
    <div>
      <MosaicInput
        inputTitle='Project ID'
        id='firebase-project-id'
        className='form-control'
        placeholder='my-awesome-campaign'
        onChange={onChange('projectId')}
        value={state.projectId}
      />
      <MosaicInput
        inputTitle='Campaign Hashtag'
        id='campaign-hashtag'
        className='form-control'
        placeholder='#bluerobotmosaics'
        onChange={onChange('title')}
        value={state.title}
      />
      <MosaicInput
        inputTitle='Client Website'
        id='mosaic-client-website'
        className='form-control'
        placeholder='https://www.bluerobot.com'
        onChange={onChange('logoLink')}
        value={state.logoLink}
      />
      <MosaicInput
        inputTitle='Logo URL'
        id='mosaic-logo-url'
        className='form-control'
        placeholder='Logo URL'
        onChange={onChange('logoSrc')}
        value={state.logoSrc}
      />
      <MosaicInput
        inputTitle='Opt Out Message'
        id='mosaic-opt-out-message'
        className='form-control'
        placeholder='To remove yourself from the Mosaic, tweet #OptOut to @bluerobot_'
        onChange={onChange('optOutText')}
        value={state.optOutText}
      />
      <CheckBox
        id='remove-br-media'
        label='Remove Blue Robot Branding?'
        className='icheckbox_square'
        input={{
          value: state.removeBRBranding,
          onChange: onChange('removeBRBranding')
        }}
      />
      <CheckBox
        id='update-existing-mosaic'
        label='Update Existing Mosaic?'
        className='icheckbox_square'
        input={{
          value: state.onlyDeploy,
          onChange: onChange('onlyDeploy')
        }}
      />
    </div>
  )
}

BasicInfo.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default BasicInfo



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-mosaic-deployment/components/BasicInfo.js